import { combineReducers } from 'redux';
import cart from './cart';
import currency from './currency';
import favorite from './favorite';
import filters from './filters';
import folders from './folders';
import geotargeting from './geotargeting';
import user from './user';
import websocket from './websocket';

const main = combineReducers({
    cart,
    currency,
    favorite,
    filters,
    folders,
    geotargeting,
    user,
    websocket
});

export default main;
